import { brand, cardBase, text } from '@/styles/shared';
export const previousHistoryTableStyles = {
  // Loading and error states
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px',
  },
  loadingText: {
    ...text.body14Muted,
  },

  // Main container
  prevHistoryCointainer: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: {
      xs: '100%',
      lg: 'calc(var(--vh, 1vh) * 100 - 180px)',
    },
  },
  historyContainer: {
    ...cardBase,
    borderBottom: '1px solid #E0E0E0',
    padding: {
      xs: '16px',
      md: '28px',
    },
    width: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
  },

  // Header section
  headerContainer: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      sm: 'row',
    },
    alignItems: 'center',
    justifyContent: {
      xs: 'center',
      sm: 'space-between',
    },
    mb: '28px',
    pb: '20px',
    borderBottom: '1px solid #E0E0E0',
    gap: '15px',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  iconContainer: {
    width: '16px',
    height: '16px',
  },
  headerText: {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '17px',
    color: '#000000',
  },

  // Column headers
  columnHeadersContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    mb: '28px',
    px: '13px',
  },
  columnHeader: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '15px',
    color: '#000000',
  },
  caseIdHeader: {
    width: '60px',
  },
  patientIdHeader: {
    width: { xs: '60px', lg: '70px' },
  },
  dateHeader: {
    width: { xs: '45px', lg: '70px' },
  },
  receivedHeader: {
    width: '70px',
  },
  durationHeader: {
    width: '90px',
  },

  // History list
  historyList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  loadingRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  // History row
  historyRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#FFFFFF',
    borderRadius: '5px',
    boxShadow: '0px 0px 10px 1px rgba(0, 0, 0, 0.05)',
    padding: '20px 13px',
    cursor: 'pointer',
    width: '100%',
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: '0px 0px 15px 2px rgba(0, 0, 0, 0.1)',
    },
  },
  selectedRow: {
    border: '2px solid #4CAF50',
  },

  // State backgrounds
  pendingRow: {
    background:
      'linear-gradient(0deg,rgba(229,194,0,.15),rgba(229,194,0,.15)),#FFF',
  },
  errorRow: {
    background:
      'linear-gradient(0deg,rgba(145,0,0,.15),rgba(145,0,0,.15)),#FFF',
  },
  completedRow: {
    background:
      'linear-gradient(0deg,rgba(0,145,2,.15),rgba(0,145,2,.15)),#FFF',
  },

  // Row text styles
  caseIdText: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '15px',
    color: '#2668E4',
    width: '60px',
  },
  rowText: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '15px',
    color: '#000000',
  },
  nameText: {
    width: { xs: '60px', lg: '80px' },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  patientIdText: {
    width: { xs: '60px', lg: '70px' },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  dateText: {
    width: { xs: '45px', lg: '70px' },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  receivedText: {
    width: '70px',
  },
  durationText: {
    width: '90px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  // Pagination
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    mt: '28px',
  },
  pagination: {
    '& .MuiPaginationItem-root': {
      fontFamily: 'Montserrat',
      color: '#000000',
      fontSize: '14px',
      fontWeight: 400,
    },
    '& .MuiPaginationItem-page': {
      '&:hover': {
        color: brand.greenPrimaryDark,
      },
    },
    '& .MuiPaginationItem-page.Mui-selected': {
      backgroundColor: brand.greenPrimary,
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: brand.greenPrimaryDark,
        fontWeight: 'normal',
      },
    },
    '& .MuiPaginationItem-root.Mui-disabled': {
      backgroundColor: '#c2c2c2 !important',
    },
  },
  headerPagination: {
    maxWidth: '410px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    '& .MuiPagination-ul': {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      maxWidth: '400px',
      '& li': {
        display: 'flex',
        justifyContent: 'center',
      },
    },
    '& .MuiPaginationItem-root': {
      fontFamily: 'Montserrat',
      color: '#000000',
      fontSize: '14px',
      fontWeight: 400,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '35px',
      height: '35px',
      borderRadius: '50%',
      '@media (max-width: 390px)': {
        width: '30px',
        height: '30px',
        fontSize: '12px',
      },
      '@media (min-width: 1200px) and (max-width: 1455px)': {
        width: '21px',
        height: '21px',
        minWidth: '21px',
        minHeight: '21px',
        fontSize: '11px',
      },
    },
    '& .MuiPaginationItem-ellipsis': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '28px',
      lineHeight: '1',
    },
    '& .MuiPaginationItem-page': {
      '&:hover': {
        color: brand.greenPrimaryDark,
      },
    },
    '& .MuiPaginationItem-page.Mui-selected': {
      border: `2px solid ${brand.greenPrimary}`,
      backgroundColor: 'transparent',
      '&:hover': {
        border: `2px solid ${brand.greenPrimaryDark}`,
        fontWeight: 'normal',
      },
    },
    '& .MuiPaginationItem-root.Mui-disabled': {
      backgroundColor: '#c2c2c2 !important',
    },
  },

  // Empty state
  emptyStateContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
  },
  emptyStateRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
  },
  emptyStateText: {
    ...text.body14Muted,
  },
} as const;
